type SimilarCarsParams = {
  make?: string | null;
  model?: string | null;
  year?: string | number | null;
  fuelType?: string | null;
  transmission?: string | null;
  bodyType?: string | null;
};

const YEAR_RANGE = 1;

const buildSimilarCarsUrl = ({
  make,
  model,
  year,
  fuelType,
  transmission,
  bodyType,
}: SimilarCarsParams): string => {
  const params = new URLSearchParams({
    sort: 'priceasc',
    sellerType: 'pro',
  });

  if (year) {
    params.append('year_from', (Number(year) - YEAR_RANGE).toString());
    params.append('year_to', (Number(year) + YEAR_RANGE).toString());
  }

  if (fuelType) {
    params.append('fuelType', fuelType);
  }

  if (transmission) {
    params.append('transmission', transmission);
  }

  if (bodyType) {
    params.append('bodyType', bodyType);
  }

  const basePath =
    make && model
      ? `/cars/${encodeURIComponent(make)}/${encodeURIComponent(model)}`
      : '/cars';

  return `${basePath}?${params.toString()}`;
};

export { buildSimilarCarsUrl };
export type { SimilarCarsParams };
